import React from 'react';
import { Dialog, DialogBackdrop, DialogPanel } from '@headlessui/react';

interface ImageLightboxProps {
  src: string;
  alt?: string;
  isOpen: boolean;
  onClose: () => void;
}

/**
 * Full-screen image viewer. Built on Headless UI's Dialog so it gets Esc-to-close,
 * backdrop-click-to-close, focus trapping and a11y for free (matching DialogComponent).
 * Clicking the image itself does not close it; clicking the backdrop does.
 */
export const ImageLightbox: React.FC<ImageLightboxProps> = ({ src, alt = '', isOpen, onClose }) => {
  return (
    <Dialog
      open={isOpen}
      as="div"
      aria-label={alt || 'Image preview'}
      className="relative z-50 focus:outline-none"
      onClose={onClose}
    >
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-black/80 duration-200 ease-out data-[closed]:opacity-0"
      />
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
        <DialogPanel
          transition
          className="duration-200 ease-out data-[closed]:opacity-0 data-[closed]:scale-95"
        >
          <img
            src={src}
            alt={alt}
            className="max-h-[85vh] max-w-[90vw] rounded-lg object-contain shadow-2xl"
          />
        </DialogPanel>
      </div>
    </Dialog>
  );
};
